import VectorIcon from './VectorIcon';

type ListIconProps = {
  stroke?: string;
  width?: number;
  height?: number;
};

const ListIcon = ({
  width = 28,
  height = 28,
  stroke = 'white',
}: ListIconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M9.33325 7H24.4999"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33325 14H24.4999"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33325 21H24.4999"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 7H3.51167"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 14H3.51167"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 21H3.51167"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </VectorIcon>
);

export default ListIcon;
